export default __webpack_public_path__ + "static/media/jimi-hendrix.34eeebd8.jpg";